import moment from 'moment';

export const DATE_RANGE_YEARS = 100;

export const getDateTimeFrameBounds = (years = DATE_RANGE_YEARS, fromDate = moment()) => {
  const from = moment(fromDate);
  return {
    minDate: from.clone().subtract(years, 'years'),
    maxDate: from.clone().add(years, 'years'),
  };
};

export const isDateWithinTimeFrame = (date, years = DATE_RANGE_YEARS, fromDate = moment()) => {
  const m = moment.isMoment(date) ? date : moment(date);
  if (!m || !m.isValid()) return false;
  const { minDate, maxDate } = getDateTimeFrameBounds(years, fromDate);
  return m.isBetween(minDate, maxDate, 'day', '[]');
};

export const formatDateSimple = (date) => moment().format('L');

export const formatDateLong = (date) => {
  const d = moment(date);
  const today = moment();
  if (d.year() === today.year()) {
    return d.format('MMM DD, hh:mma');
  } else {
    return d.format('MMM DD, YYYY');
  }
};

export const formatDateFromNow = (date) => moment(date).fromNow();
